module.exports = __webpack_public_path__ + "img/10.c4dd584b.jpg";